import { SvgCurve, SvgTxt, MaterialRecord, MaterialSvg } from "../components/DrawMtrlCurve";

function ReinfCurve(activeMtrl: MaterialRecord, svg: MaterialSvg): [SvgCurve[], SvgTxt[]] {
  const name = activeMtrl["name"].toString();
  const E = activeMtrl["units"]["elasticityModulus"] / 1e9; //Gpa

  const yieldS = activeMtrl["units"]["yieldStrength"] / 1e6; //Mpa
  const yieldE = Number((yieldS / E).toFixed(1)); // promille

  let ultimateS = activeMtrl["units"]["ultimateStrength"] / 1e6; //Mpa
  let ultimateE = activeMtrl["units"]["epsilonUltimate"] * 1.0e3; // promille

  const scaleW = svg.max.x / ultimateE;
  const scaleH = svg.max.y / ultimateS;

  // stress-strain curve --------------------------------

  let curve1: SvgCurve = {
    stroke: "magenta",
    width: "1",
    dash: "",
    data: "",
  };

  curve1.data = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " ";

  curve1.data += "l" + (yieldE * scaleW).toString() + "," + (-yieldS * scaleH).toString();
  curve1.data += "l" + ((ultimateE - yieldE) * scaleW).toString() + "," + (-(ultimateS - yieldS) * scaleH).toString();

  // 'fyk'-line  --------------------------------

  let curve2: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve2.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - yieldS * scaleH).toString() + " ";
  curve2.data += "l" + (yieldE * scaleW + 5).toString() + ",0";

  // 'eps_y'-line  --------------------------------

  let curve3: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve3.data = "M" + (svg.origo.x + yieldE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve3.data += "l" + "0," + (-(yieldS * scaleH + 5)).toString();

  // 'eps_u'-line  --------------------------------

  let curve4: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve4.data = "M" + (svg.origo.x + ultimateE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve4.data += "l" + "0," + (-(ultimateS * scaleH + 5)).toString();

  // 'fuk'-line  --------------------------------

  let curve5: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve5.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - ultimateS * scaleH).toString() + " ";
  curve5.data += "l" + (ultimateE * scaleW + 5).toString() + ",0";

  //---- collect curves -----------------

  let curves = [curve1, curve2, curve3, curve5];

  //---- texts -----------------
  let pad = 0;
  // if (ultimateS - yieldS < 75) pad = -20;
  let yPad = 0;

  let txts: SvgTxt[] = [
    {
      x: (svg.origo.x + svg.max.x / 2 - (name.length * 10) / 2).toString(),
      y: (svg.origo.y - svg.max.y - 20).toString(),
      style: {
        fontSize: "20px",
        fontStyle: "normal",
      },
      text: '"' + name + '"',
    },

    {
      x: (svg.origo.x + yieldE * scaleW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + yieldE * scaleW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "y",
    },
    {
      x: (svg.origo.x + ultimateE * scaleW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + ultimateE * scaleW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u",
    },
    {
      x: (svg.origo.x - 40).toString(),
      y: (svg.origo.y - yieldS * scaleH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "f",
    },
    {
      x: (svg.origo.x - 35).toString(),
      y: (svg.origo.y + 5 - yieldS * scaleH).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u|y",
    },
    // {
    //   x: (svg.origo.x - 30 + pad).toString(),
    //   y: (svg.origo.y - ultimateS * scaleH - yPad).toString(),
    //   style: {
    //     fontSize: "20px",
    //     fontWeight: "bold",
    //     fontStyle: "italic",
    //   },
    //   text: "f",
    // },
    // {
    //   x: (svg.origo.x - 25 + pad).toString(),
    //   y: (svg.origo.y + 5 - ultimateS * scaleH - yPad).toString(),
    //   style: {
    //     fontSize: "15px",
    //     fontWeight: "bold",
    //     fontStyle: "italic",
    //   },
    //   text: "u",
    // },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 - 35).toString(),
      style: {
        fontSize: "15px",
        fontStyle: "italic",
      },
      text: "E = " + E.toString() + " GPa",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 - 15).toString(),
      style: {
        fontSize: "15px",
        fontStyle: "italic",
      },
      text: "f    = " + ultimateS.toString() + " MPa",
    },
    {
      x: (svg.origo.x + svg.max.x / 2 - 35).toString(),
      y: (svg.origo.y - svg.max.y / 2 - 10).toString(),
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 5).toString(),
      style: {
        fontSize: "15px",
        fontStyle: "italic",
      },
      text: "f    = " + yieldS.toString() + " MPa",
    },
    {
      x: (svg.origo.x + svg.max.x / 2 - 35).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 10).toString(),
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "y",
    },

    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 25).toString(),
      style: {
        fontSize: "15px",
        fontStyle: "italic",
      },
      text: "&epsilon;    = " + yieldE.toString() + " &permil;",
    },
    {
      x: (svg.origo.x + svg.max.x / 2 - 35).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 30).toString(),
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "y",
    },
    {
      x: (svg.origo.x + svg.max.x / 2 - 40).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 45).toString(),
      style: {
        fontSize: "15px",
        fontStyle: "italic",
      },
      text: "&epsilon;    = " + ultimateE.toString() + " &permil;",
    },
    {
      x: (svg.origo.x + svg.max.x / 2 - 35).toString(),
      y: (svg.origo.y - svg.max.y / 2 + 50).toString(),
      style: {
        fontSize: "10px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u",
    },
  ];

  return [curves, txts];
}

export default ReinfCurve;
